export default function numberWithDots(str) {
  if (!str) {
    return '';
  }
  return str
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    .trim();
}
